<script setup>
import { defineProps, defineEmits, computed } from "vue";
import { booleanHook } from "@/common/hooks/booleanHook.js";
import AtomIcon from "@/common/ui/Icon.vue";
import InputWrapper from "./InputWrapper";

const emits = defineEmits(["update:modelValue"]);

const updateValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

const props = defineProps({
  id: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  class: {
    type: String,
    default: "",
  },
  autocomplete: {
    type: String,
    default: "",
  },
  disabled: Boolean,
  modelValue: {
    type: String,
    default: "",
  },
  showEye: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array,
    default: () => [],
  },
});

const showPassword = booleanHook();

const inputType = computed(() => {
  return showPassword.flag.value ? "text" : "password";
});
</script>

<template>
  <InputWrapper
    :id="id"
    :label="label"
    :class="props.class"
    :disabled="disabled"
    :error="error"
    :errors="errors"
  >
    <input
      :id="props.id"
      v-model="updateValue"
      :name="props.name"
      :autocomplete="props.autocomplete"
      :type="inputType"
      :disabled="disabled"
      :placeholder="placeholder"
    />

    <AtomIcon
      v-if="showPassword.flag.value"
      name="tmp-patients-status-4"
      @click="showPassword.toggle"
    />
    <AtomIcon
      v-if="!showPassword.flag.value"
      name="tmp-patients-status-6"
      @click="showPassword.toggle"
    />
  </InputWrapper>
</template>

<style lang="scss" scoped>
@import "/src/modules/ras/views/index";
@import "../../assets/theme/default/colors";

:deep() {
  .form-control {
    display: flex;

    &--disabled {
      background-color: $white-mist-bg;
    }
    .icon {
      path {
        fill: $gray-medium;
      }
      cursor: pointer;
    }
  }

  .control-label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }

  .error-message {
    color: red;
    font-size: 0.75rem;
  }
}
.form-control {
  input {
    border: 0;
    flex: 1;
    &:focus {
      outline: none;
    }
  }
}
</style>
